// The Phase 3 localization build flag (VITE_I18N, see vite.config.ts).
//
// Every runtime decision asks this function, so a test switches the app with
// one `vi.mock('.../i18n/flag')`, and the flag-on test run
// (vitest.i18n-on.config.ts) defines the global as true.
//
// The one other reader of `__I18N__` is the lazy locale loader table in
// src/i18n/index.ts, and only because the bundler has to see a literal there:
// a function call in between defeats Rolldown's dead-code elimination
// (measured: with a call, or even an exported const from this module, the
// locale chunks were still emitted in a flag-off build).
//
// Flag off is the contract that nothing changes: the language is always
// English, no detection runs, no switcher renders, no X-Interface-Language
// header is sent, and the es/pt/ja catalogs are not in the bundle.
export function i18nEnabled(): boolean {
  return __I18N__
}
